import { render, staticRenderFns } from "./PublicIntroduce.vue?vue&type=template&id=531d2cb2&scoped=true"
import script from "./PublicIntroduce.vue?vue&type=script&lang=js"
export * from "./PublicIntroduce.vue?vue&type=script&lang=js"
import style0 from "./PublicIntroduce.vue?vue&type=style&index=0&id=531d2cb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531d2cb2",
  null
  
)

export default component.exports